import { generatePath, Navigate } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import type { FeatureIslandHeaderLangNavigatorProps } from "@/components/features/_layouts";

import { RoomI18nEditPresenter } from "./presenter";
import { useRoomI18nEditQuery } from "../../model/repository/existing/query/use-room-i18n-edit-query";

type Props = {
	hotelID: string;
	roomID: string;
	activeLangCode: LangCode;
	navigator: FeatureIslandHeaderLangNavigatorProps;
};

export const RoomI18nEditContainer = ({ hotelID, roomID, activeLangCode, navigator }: Props) => {
	const serverModel = useRoomI18nEditQuery({ hotelID, roomID, lang: activeLangCode });

	if (!serverModel) {
		return <Navigate to={generatePath(PATHS.HOTEL.ITEMS.ROOM.TOP, { hotelID })} />;
	}

	return <RoomI18nEditPresenter activeLangCode={activeLangCode} navigator={navigator} serverModel={serverModel} />;
};

RoomI18nEditContainer.displayName = "RoomI18nEditContainer";
